// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const ViewWarehouseAvailability = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13">
            <path
                fill="currentColor"
                d="M14.25,9 L12.75,9 L12.75,0.728906393 C12.75,0.31640625 12.4124994,0 12,0 C11.5875006,0 11.25,0.337499857 11.25,0.728906393 L11.25,10.125 C11.25,10.3312497 11.4187503,10.5 11.625,10.5 L14.25,10.5 C14.6624994,10.5 15,10.1625001 15,9.77109361 C15,9.37968707 14.6624994,9 14.25,9 Z M9.75,5.55703139 C9.75,5.35195327 9.70898438,5.15273452 9.62695312,4.96523452 L7.79296875,0.680859089 C7.61484361,0.266718864 7.20937514,0 6.75703096,0 L3.375,0 C2.75390625,0 2.25,0.50390625 2.25,1.125 L2.25,3.75 L1.125,3.75 C0.50390625,3.75 0,4.25390625 0,4.875 L0,9.75 C0,10.9921875 1.0078125,12 2.25,12 C3.4921875,12 4.5,10.9921875 4.5,9.75 L6,9.75 C6,10.9921875 6.98671889,12 8.22890639,12 C9.47109389,12 10.5,10.9921875 10.5,9.75 C10.5,9.08789062 10.2070312,8.49656224 9.77109361,8.08335972 L9.75,5.55703139 Z M2.25,10.875 C1.62890625,10.875 1.125,10.3710938 1.125,9.75 C1.125,9.12890625 1.62890625,8.625 2.25,8.625 C2.87109375,8.625 3.375,9.12890625 3.375,9.75 C3.375,10.3710938 2.87109375,10.875 2.25,10.875 Z M6,6 L3.75,3.75 L3.75,1.5 L6.51093721,1.5 L8.25117159,5.55703139 L8.25117159,6 L6,6 Z M8.25,10.875 C7.62890625,10.875 7.125,10.3710938 7.125,9.75 C7.125,9.12890625 7.62890625,8.625 8.25,8.625 C8.87109375,8.625 9.375,9.12890625 9.375,9.75 C9.375,10.3710938 8.87109375,10.875 8.25,10.875 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(ViewWarehouseAvailability);
